import { ColumnType, Row } from "@asayinc/component-library";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";

import { IProxyEvent } from "src/store/proxyEvent/types";
import { PROXY_EVENT_LABEL } from "src/constants/labels/proxyEventLabel";
import { InformationalProxyEventsView } from ".";
import { INFORMATIONAL_PROXY_EVENTS_VIEW } from ".";

dayjs.extend(relativeTime);
dayjs.extend(utc);

export const UPCOMING_COLUMNS = ["type", "issuer"];

export const ACTIVE_COLUMNS = ["type", "issuer"];

export const RECENTLY_COMPLETED_COLUMNS = ["type", "issuer"];

export const HISTORICAL_COLUMNS = ["type", "issuer"];

export type ColumnDataHelpers = {
  getSort: (sortKey: string) => "asc" | "desc" | undefined;
  onOrderingChange: (data: unknown, sortKey: string) => void;
};

export type UpcomingColumnData = {
  type: ColumnType;
  issuer: ColumnType;
};

export type ActiveColumnData = {
  type: ColumnType;
  issuer: ColumnType;
};

export type RecentlyCompletedColumnData = {
  type: ColumnType;
  issuer: ColumnType;
};

export type HistoricalColumnData = {
  issuer: ColumnType;
  type: ColumnType;
};

export function getColumns(view: InformationalProxyEventsView) {
  if (view === INFORMATIONAL_PROXY_EVENTS_VIEW.UPCOMING) {
    return UPCOMING_COLUMNS;
  } else if (view === INFORMATIONAL_PROXY_EVENTS_VIEW.ACTIVE) {
    return ACTIVE_COLUMNS;
  } else if (view === INFORMATIONAL_PROXY_EVENTS_VIEW.RECENTLY_COMPLETED) {
    return RECENTLY_COMPLETED_COLUMNS;
  } else {
    return HISTORICAL_COLUMNS;
  }
}

export function getColumnData(
  view: string,
  { getSort, onOrderingChange }: ColumnDataHelpers
):
  | UpcomingColumnData
  | ActiveColumnData
  | RecentlyCompletedColumnData
  | HistoricalColumnData {
  if (view === INFORMATIONAL_PROXY_EVENTS_VIEW.UPCOMING) {
    return {
      type: {
        sort: getSort("type"),
        sortFn: (data: unknown) => onOrderingChange(data, "type"),
        style: "text",
        title: "Type",
        tdBodyProps: {
          textProps: {
            weight: 600,
          },
        },
        width: "22%",
      },
      issuer: {
        sort: getSort("issuer__name"),
        sortFn: (data: unknown) => onOrderingChange(data, "issuer__name"),
        style: "text",
        title: "Issuer",
        tdBodyProps: {
          textProps: {
            weight: 600,
          },
        },
        width: "22%",
      },
    };
  } else {
    return {
      type: {
        sort: getSort("type"),
        sortFn: (data: unknown) => onOrderingChange(data, "type"),
        style: "text",
        title: "Type",
        tdBodyProps: {
          textProps: {
            weight: 600,
          },
        },
      },
      issuer: {
        sort: getSort("issuer__name"),
        sortFn: (data: unknown) => onOrderingChange(data, "issuer__name"),
        style: "text",
        title: "Issuer",
        tdBodyProps: {
          textProps: {
            weight: 600,
          },
        },
      },
    };
  }
}

export function getRowData(
  view: string,
  events: IProxyEvent[],
  onRowClick: (event: IProxyEvent) => void
): Row[] {
  const handleRowClick = (data: unknown) => {
    const { event } = data as {
      event: IProxyEvent;
      idx: string;
    };
    onRowClick(event);
  };

  if (view === INFORMATIONAL_PROXY_EVENTS_VIEW.UPCOMING) {
    return events.map((event, idx) => {
      const { id, securities, type } = event;

      return {
        id,
        data: { event, idx },
        rowData: {
          issuer: {
            content: securities[0] ? securities[0].issuerName : "-",
            clickHandler: handleRowClick,
          },
          type: {
            content: PROXY_EVENT_LABEL[type],
            clickHandler: handleRowClick,
          },
        },
      };
    });
  } else {
    return events.map((event, idx) => {
      const { id, securities, type } = event;

      return {
        id,
        data: { event, idx },
        rowData: {
          issuer: {
            content: securities[0] ? securities[0].issuerName : "-",
            clickHandler: handleRowClick,
          },
          type: {
            content: PROXY_EVENT_LABEL[type],
            clickHandler: handleRowClick,
          },
        },
      };
    });
  }
}
